import styled from 'styled-components';
import Load05 from 'dc/Load05';

export const Wrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  padding: 0 16px;
`;

export const LoaderDots = styled(Load05)``;
